import Image from 'next/image';
import { useIntl } from 'react-intl';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { MoneyFragment } from '@/graphql/saleor/api';
import type { Maybe } from '@/lib/types';
import { commonMessages } from '@/messages/common';
import { useConfigProvider } from '@/providers/ConfigProvider';

import AgosIcon from '@/assets/icons/agos.svg';

import * as S from '../ProductDetail.styles';

interface AgosSentenceProps {
  onCalculateFinancing: () => void;
  price: Maybe<MoneyFragment>;
  variantCTA?: OrderAppCtaType;
}

export const AgosSentence = ({
  onCalculateFinancing,
  price,
  variantCTA,
}: AgosSentenceProps) => {
  const { formatMessage } = useIntl();

  const { agosPaymentMax, agosPaymentMin } = useConfigProvider();

  if (!price || variantCTA !== 'ORDER') return null;

  if (price.amount < agosPaymentMin || price.amount > agosPaymentMax)
    return null;

  return (
    <Flex flexDirection='column' marginBottom='s100'>
      <Flex alignItems='center' marginBottom='s050'>
        <Typography fontFamily='openSans'>
          {formatMessage(commonMessages.agosMessage)}
        </Typography>
        &nbsp;
        <Image alt='agos' height={22} src={AgosIcon} width={48} />
      </Flex>
      <S.LearnMore
        data-testid='agosCalculateFinancing'
        onClick={onCalculateFinancing}
      >
        {formatMessage(commonMessages.agosCalculateFinancing)}
      </S.LearnMore>
    </Flex>
  );
};
